import React from 'react';
import {  Head } from 'react-static';

export default ({ image, pageDescription, pageTitle, imageAltText }) => {
  const title = `${pageTitle} | Northwestern Mutual`;
  const description = pageDescription;
  const imageAlt = imageAltText;
  const url = 'https://www.northwesternmutual.com/';
  const publisher = 'Northwestern Mutual';
  const imageAbsolutePath = `https://www.northwesternmutual.com${image}`;

  return (
    <Head>
      <meta name="addsearch-category" content="Insurance" />
      <meta name="keywords" content="" />
      <meta name="author" content={publisher} />

      <meta name="google-site-verification" content="L-0rab9xqBqLkdhmyeIErNZSuDpljnE-5lHbudU0Ovg" />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta property="og:site_name" content={publisher} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:image" content={image} data-react-helmet="true" />

      <meta name="twitter:site" content="@NM_Financial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@NM_Financial" />
      <meta name="twitter:creator:id" content="@NM_Financial" />
      <meta name="twitter:image" content={imageAbsolutePath} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  );
};
